export { HorizontalTabs, HorizontalTabsPlacement } from "./HorizontalTabs";
export type { HorizontalTabsProps, TabItem } from "./HorizontalTabs";
